import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const zabbix = defineConnector({
  identifier: "zabbix",
  name: "Zabbix",
  tagLine: "Infrastructure monitoring",
  logo,
  protocol: "http",
  tags: ["observability", "it"],
  defaultUrlPattern: () => "https://[^/]*zabbix[^/]*/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your Zabbix API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Zabbix instance and navigate to **Users › API Tokens** to generate an API token.",
        },
      ],
    },
    {
      title: "Enter your Zabbix details",
      items: [
        {
          kind: "url",
          label: "Zabbix URL",
          required: true,
          placeholder: "https://zabbix.example.com",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "The base URL of your Zabbix instance.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api_jsonrpc.php`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    ZABBIX_URL: baseUrl || "",
  }),
});
